<template>
  <v-container>
    <v-content class="mic_container">

        <v-toolbar card color="#5ba322" dark class="mic_form-spacer">
          <v-toolbar-title>Deine Verlaufsdaten</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

      <v-toolbar dark color="#5ba322">
        <v-toolbar-title>Gewicht [kg]</v-toolbar-title>
        <span class="v-tooltip v-tooltip--right"> </span>
      </v-toolbar>

      <GChart type="LineChart" :data="chartData" :options="chartOptions" />
      <v-toolbar dark color="#5ba322">
        <v-toolbar-title>
          Blutzucker nüchtern [mg/dl] und Langezeitzucker HbA1c [mmol/mol]
        </v-toolbar-title>
        <span class="v-tooltip v-tooltip--right"> </span>
      </v-toolbar>
      <GChart
        type="LineChart"
        :data="chartSugarData"
        :options="chartOptionsLegend"
      /><v-toolbar dark color="#5ba322">
        <v-toolbar-title>Blutdruck [mmHg]</v-toolbar-title>
        <span class="v-tooltip v-tooltip--right"> </span>
      </v-toolbar>
      <GChart
        type="ColumnChart"
        :data="chartPressureData"
        :options="chartOptionsLegend"
      /><v-toolbar dark color="#5ba322">
        <v-toolbar-title>Bewegung [Stunden pro Woche]</v-toolbar-title>
        <span class="v-tooltip v-tooltip--right"> </span>
      </v-toolbar>
      <GChart type="ColumnChart" :data="chartMoveData" :options="chartOptions" />
    </v-content>
  </v-container>
</template>

<script>
import { trackingService } from '../_services'
import { GChart } from 'vue-google-charts'
import { dataToChart } from '../_helpers/dataToChart'

export default {
  name: 'App',
  components: {
    GChart
  },
  data () {
    return {
      // Array will be automatically processed with visualization.arrayToDataTable function
      chartData: [],
      chartSugarData: [],
      chartPressureData: [],
      chartMoveData: [],

      chartOptions: {
        height: 450,
        colors: ['#358948', '#a01831'],
        pointSize: 5,
        legend: { position: 'none' }
      },
      chartOptionsLegend: {
        height: 450,
        colors: ['#358948', '#a01831'],
        pointSize: 5
      }
    }
  },
  created () {
    trackingService
      .getTrackingsForUser(JSON.parse(localStorage.getItem('user')).id)
      .then(response => {
        this.loading = false
        this.chartData = dataToChart(response.data, 'weight')
        this.chartSugarData = dataToChart(
          response.data,
          'bloodsugar',
          'longtermSugar'
        )
        this.chartPressureData = dataToChart(
          response.data,
          'systolic',
          'diastolic'
        )
        this.chartMoveData = dataToChart(response.data, 'weeklyHoursMotion')
        console.log(this.chartSugarData)
      })
      .catch(error => {
        this.loading = false
        console.error(error)
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/charts/ChartPage.vue